export default class TranslationApiModel {
  constructor(rawModel) {
    this.Translations = rawModel?.Translations || null
    this.TranslatableFields = rawModel?.TranslatableFields || null
    this.TotalOfTranslatableFields = rawModel?.TotalOfTranslatableFields || null
    this.LanguageProgress = rawModel?.LanguageProgress || null
    this.AvailableCultures = rawModel?.AvailableCultures || null
    this.DefaultCulture = rawModel?.DefaultCulture || null
  }
}
